/**
 * SEO Articles Infinite Scroll / Load More
 */
class SeoArticlesLoader {
    constructor() {
        this.currentPage = 1;
        this.totalPages = 1;
        this.category = '';
        this.isLoading = false;
        this.container = null;
        this.loadMoreBtn = null;
        
        this.init();
    }
    
    init() {
        this.container = document.getElementById('articles-container');
        this.loadMoreBtn = document.getElementById('load-more-btn');
        
        if (!this.container) {
            return;
        }
        
        // Get initial data from button
        if (this.loadMoreBtn) {
            this.currentPage = parseInt(this.loadMoreBtn.dataset.page) || 1;
            this.totalPages = parseInt(this.loadMoreBtn.dataset.totalPages) || 1;
            this.category = this.loadMoreBtn.dataset.category || '';
            
            // Bind click event
            this.loadMoreBtn.addEventListener('click', () => {
                this.loadMore();
            });
        }
        
        // Setup intersection observer for infinite scroll
        this.setupIntersectionObserver();
    }
    
    setupIntersectionObserver() {
        if (!('IntersectionObserver' in window)) {
            return;
        }
        
        const options = {
            root: null,
            rootMargin: '200px',
            threshold: 0.1
        };
        
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isLoading && this.currentPage < this.totalPages) {
                    this.loadMore();
                }
            });
        }, options);
        
        // Observe load more button or last article
        if (this.loadMoreBtn) {
            this.observer.observe(this.loadMoreBtn);
        } else if (this.container) {
            // Observe last article card for infinite scroll
            const lastCard = this.container.querySelector('.col-md-6.col-lg-3:last-child');
            if (lastCard) {
                this.observer.observe(lastCard);
            }
        }
    }
    
    async loadMore() {
        if (this.isLoading || this.currentPage >= this.totalPages) {
            return;
        }
        
        this.isLoading = true;
        this.currentPage++;
        
        // Show loading state
        if (this.loadMoreBtn) {
            const spinner = this.loadMoreBtn.querySelector('.spinner-border');
            const btnText = this.loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.classList.remove('d-none');
            if (btnText) btnText.textContent = 'Đang tải...';
            this.loadMoreBtn.disabled = true;
        }
        
        try {
            const url = new URL('/tin-tuc/load-more', window.location.origin);
            url.searchParams.set('page', this.currentPage);
            if (this.category) {
                url.searchParams.set('category', this.category);
            }
            
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            
            const data = await response.json();
            
            if (data.success && data.html) {
                // Append new articles
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data.html;
                const newArticles = tempDiv.querySelectorAll('.col-md-6.col-lg-3');
                
                newArticles.forEach(article => {
                    this.container.appendChild(article);
                });
                
                // Update pagination info
                this.totalPages = data.total_pages;
                this.currentPage = data.current_page;
                
                // Update observer if button is hidden
                if (!data.has_more) {
                    if (this.loadMoreBtn) {
                        this.loadMoreBtn.style.display = 'none';
                    }
                    if (this.observer) {
                        this.observer.disconnect();
                    }
                } else if (this.loadMoreBtn && this.observer) {
                    // Re-observe button if it's still visible
                    this.observer.observe(this.loadMoreBtn);
                }
            } else {
                throw new Error('Invalid response data');
            }
        } catch (error) {
            console.error('Error loading more articles:', error);
            this.currentPage--; // Revert page increment
            
            // Show error message
            if (this.loadMoreBtn) {
                const btnText = this.loadMoreBtn.querySelector('.btn-text');
                if (btnText) btnText.textContent = 'Có lỗi xảy ra. Nhấn để thử lại.';
            }
        } finally {
            this.isLoading = false;
            
            // Reset button state
            if (this.loadMoreBtn) {
                const spinner = this.loadMoreBtn.querySelector('.spinner-border');
                const btnText = this.loadMoreBtn.querySelector('.btn-text');
                if (spinner) spinner.classList.add('d-none');
                if (btnText && this.currentPage < this.totalPages) {
                    btnText.textContent = 'Tải thêm bài viết';
                }
                this.loadMoreBtn.disabled = false;
            }
        }
    }
}

export default SeoArticlesLoader;

